module.exports = ".fa-lg {\n  font-size: 1.33333333em;\n  line-height: 1em;\n  vertical-align: -15%;\n  padding: 8px; }\n\ntr.td-data-table-row {\n  height: 80px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/consulta/resumenpaciente/resumenpaciente.component.scss
// module id = ./src/app/consulta/resumenpaciente/resumenpaciente.component.scss
// module chunks = main